import React from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceTodoListItemDescription_todo$key } from "./__generated__/WorkspaceTodoListItemDescription_todo.graphql";
import { ListItemDescriptionContent } from "../../Team/TeamHomeNavigator/TeamScheduleListItem/ListItemDescriptionContent";

export function WorkspaceTodoListItemDescription(props: {
  workspaceTodo: WorkspaceTodoListItemDescription_todo$key;
}) {
  const workspaceTodo = useFragment(
    graphql`
      fragment WorkspaceTodoListItemDescription_todo on TodoWorkspace {
        title

        descriptionImages {
          ...ListItemDescriptionContent_images
        }
        descriptionFiles {
          ...ListItemDescriptionContentFiles_files
        }
        linkedProducts {
          ...ListItemDescriptionContentProducts_products
        }
      }
    `,
    props.workspaceTodo
  );

  return (
    <ListItemDescriptionContent
      products={workspaceTodo.linkedProducts}
      images={workspaceTodo.descriptionImages}
      title={workspaceTodo.title}
      files={workspaceTodo.descriptionFiles}
    />
  );
}
